"use client";

import { GlobalContext } from "@/contexts/SiteDataContext";
import { sendViewItemEvent, sendViewItemListEvent } from "@/services/DataLayer/events";
import { useContext, useEffect, useState } from "react";

type DataLayerFunctionType = "sendViewItemListEvent" | "sendViewItemEvent";

type EventFunction = (formNames: any, price: number) => void;

const eventHandlers: { [key in DataLayerFunctionType]: EventFunction } = {
  sendViewItemListEvent: sendViewItemListEvent,
  sendViewItemEvent: sendViewItemEvent,
};

interface DataLayerClientProps {
  dataLayerFunction: DataLayerFunctionType;
  productName: string[] | string;
}

const DataLayerClient: React.FC<DataLayerClientProps> = ({ dataLayerFunction, productName }) => {
  const siteData = useContext(GlobalContext).context.siteData;
  const [dataLayerEvent, setDataLayerEvent] = useState<any>(null);

  useEffect(() => {
    const price = siteData.formAmount;
    const eventHandler = eventHandlers[dataLayerFunction] || (() => {});

    setDataLayerEvent(eventHandler(productName, price));
  }, []);

  return dataLayerEvent;
};

export default DataLayerClient;
